import { render } from "./TeacherMaster.vue?vue&type=template&id=0041e8e1&scoped=true"
import script from "./TeacherMaster.vue?vue&type=script&lang=js"
export * from "./TeacherMaster.vue?vue&type=script&lang=js"

import "./TeacherMaster.vue?vue&type=style&index=0&id=0041e8e1&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0041e8e1"]])

export default __exports__